import { countrySwitch } from 'services/geo-management'

export const DEFAULT_GUESTS_FOR_PRICING = 30
export const GLOBAL_VAT_RATE = countrySwitch(22, {
  SE: 25,
})

export const round =
  (decimals = 2) =>
  (num: number) => {
    const roundFactor = Math.pow(10, decimals)
    return Math.round(num * roundFactor) / roundFactor
  }
export const roundToOneDecimal = round(1)

export const truncate = (num: number, decimals?: number) => {
  const truncFactor = Math.pow(10, decimals ?? 0)
  return Math.trunc(num * truncFactor) / truncFactor
}

export const getNetPriceFromMargin = (
  marginPerc: number,
  costNoVat: number
) => {
  return costNoVat / (1 - marginPerc / 100)
}
export const getGrossPriceFromMargin = (margin: number, costNoVat: number) =>
  getNetPriceFromMargin(margin, costNoVat) * (1 + GLOBAL_VAT_RATE / 100)

export const getDiscountedPrice = (price: number, discountPerc: number) =>
  truncate(price * (1 - discountPerc / 100))

export const getVatFromNet = (netPrice: number, vatRate = GLOBAL_VAT_RATE) =>
  truncate((netPrice / 100) * vatRate, 2)

export const getGrossFromNet = (netPrice: number, vatRate = GLOBAL_VAT_RATE) =>
  truncate(netPrice * (1 + vatRate / 100), 2)

export const getMarginProductMargin = (
  marginPerc: number,
  costNoVat: number
) => {
  return (
    (getNetPriceFromMargin(marginPerc, costNoVat) - costNoVat) /
    DEFAULT_GUESTS_FOR_PRICING
  )
}

export const getMarginProductNetPrice = (
  marginPerc: number,
  costNoVatPerDefaultGuests: number
) =>
  getNetPriceFromMargin(marginPerc, costNoVatPerDefaultGuests) /
  DEFAULT_GUESTS_FOR_PRICING

export const getMarginProductInboundVat = (
  marginPerc: number,
  costNoVat: number
) =>
  ((costNoVat / (1 - marginPerc / 100)) * (GLOBAL_VAT_RATE / 100)) /
  DEFAULT_GUESTS_FOR_PRICING

export const getMargin = (netPrice: number, costNoVat: number) =>
  netPrice - costNoVat

export const getMarginPerc = (margin: number, price: number) =>
  (margin / price) * 100

export const getMarginPercFromPriceAndCost = (price: number, cost: number) =>
  getMarginPerc(getMargin(price, cost), price)

export const getVatEffect = (serviceVat: number, vat: number) =>
  serviceVat - vat
